module.exports = __webpack_public_path__ + "img/logo_title.b19d763c.png";